import { render, staticRenderFns } from "./NewGroupedDocumentEditView.vue?vue&type=template&id=3a6bc9f6&scoped=true&"
import script from "./NewGroupedDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./NewGroupedDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./NewGroupedDocumentEditView.vue?vue&type=style&index=0&id=3a6bc9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bc9f6",
  null
  
)

export default component.exports